import styled from 'styled-components';

import { Heading2 } from 'packages/smart-home-support/components/Typography';

export default styled(Heading2)<{ inverted: boolean }>`
  color: ${(props) => (props.inverted ? '#fff' : 'inherit')};
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/components/WhatsCoveredCallToActionTitle.tsx